import React from 'react'
import { useForm } from 'react-hook-form'
import { IconMail } from '@tabler/icons-react'
import { useAuth } from '../../../Auth/AuthProvider'
import { Link, useNavigate } from 'react-router-dom'
import Spinner from '../../../Components/Spinner'

const fieldClass =
  'w-full border border-mauve-200 bg-white px-3 py-2 text-mauve-900 outline-none transition focus:border-mauve-500'

export default function RegisterForm(props) {
  const { register, handleSubmit } = useForm()
  const { registerWithEmail } = useAuth()
  const navigate = useNavigate()

  const createNewUser = ({ displayName, registerEmail, registerPassword1, registerPassword2 }) => {
    if (registerPassword1 && registerPassword1 === registerPassword2) {
      props.handleLogin('email', true)
      registerWithEmail({
        email: registerEmail,
        password: registerPassword1,
        displayName,
      })
        .then(() => {
          props.handleLogin('email', false)
          navigate(props.userHomePath)
        })
        .catch((err) => {
          props.handleLogin('email', false)
          props.handleError('email', err.message)
        })
    } else {
      props.handleError('email', 'The two passwords does not match')
    }
  }

  return (
    <form onSubmit={handleSubmit(createNewUser)} className="space-y-3">
      <input {...register('displayName')} className={fieldClass} placeholder="Name" type="text" defaultValue="" />
      <input {...register('registerEmail')} className={fieldClass} placeholder="Email" type="email" defaultValue="" />
      <input {...register('registerPassword1')} className={fieldClass} placeholder="Password" type="password" defaultValue="" />
      <input {...register('registerPassword2')} className={fieldClass} placeholder="Repeat password" type="password" defaultValue="" />
      {props.error ? <p className="text-sm text-red-600">{props.error}</p> : null}
      <button
        type="submit"
        className="flex w-full items-center justify-center gap-2 bg-mauve-800 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-mauve-900"
      >
        {props.loggingIn ? (
          <Spinner className="text-white" />
        ) : (
          <>
            <IconMail className="size-4" />
            CREATE ACCOUNT
          </>
        )}
      </button>
      <p className="text-sm italic text-mauve-500">
        Already have an account?{' '}
        <Link to="/login" className="text-mauve-700 not-italic hover:text-mauve-900">
          Sign in
        </Link>
      </p>
    </form>
  )
}
